module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Intimate-celebrations.a6704faa.jpg";